import React, { useEffect, useState } from "react";
import { Button } from "@vds/buttons";
import { Modal } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { DropdownSelect } from "@vds/selects";
import { RadioBox } from "@vds/radio-boxes";
import { Input } from "@vds/inputs";
import { Line } from "@vds/lines";
import {
  filterFloorsBySite,
  getFloorNameById,
  getSiteNameById,
} from "../../../global/utility/Utils";
import { Notification } from "@vds/notifications";
import {
  PatchDeviceInfo,
  updateCameraCredentials,
} from "../../../api/DeviceServiceManager";
import { useDispatch, useSelector } from "react-redux";
import {
  getDiscoveredCamForComp,
  showNotificationBanner,
  updateCompanionDeviceSite,
  getAllCompanionDevices,
} from "../../../store/actions";
import { Loader } from "@vds/loaders";
import { useLocation } from "react-router-dom";
import {
  enableEvidenceStatesEndPoint,
  disableEvidenceStatesEndPoint,
} from "../../../configuration";
import axiosInstance from "../../../global/axiosInterceptor";

const CompanionOnboardingModal = ({
  title,
  showModal = false,
  setShowModal,
  selectedRowId,
  type = "",
  eventVideoStatus = false,
}) => {
  const data = useSelector((state) => state.deviceReducer);
  const companionList = data.companionDeviceList;
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const companionD =
    companionList?.length > 0
      ? companionList.find((c) => c.qrcode == selectedRowId)
      : "";
  const { siteTagList } = useSelector((state) => state?.sitesReducer);
  const [deviceInfo, setDeviceInfo] = useState({});
  const [step, setStep] = useState(1);
  const [sendVideo, setSendVideo] = useState(true);
  const [site, setSite] = useState("");
  const [floor, setFloor] = useState("");
  const [companionDeviceName, setCompanionDeviceName] = useState("");
  const [cameraUsername, setCameraUsername] = useState("service");
  const [cameraPassword, setCameraPassword] = useState("Service.1234");
  const [sitesList, setSitesList] = useState(siteTagList?.sites || []);
  const [loading, setLoading] = useState(false);
  const [floors, setFloors] = useState(siteTagList?.floors || []);
  const [isFloorDisabled, setIsFloorDisabled] = useState(true);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [notification, setNotification] = React.useState({
    show: false,
    type: "",
    message: "",
    subtitle: "",
  });
  const [selectedButton, setSelectedButton] = useState("Next");

  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    setIsFloorDisabled(site === "");
    setIsNextDisabled(site === "");
  }, [site]);

  useEffect(() => {
    const hideNotification = () => {
      setTimeout(() => {
        setNotification({ ...notification, show: false });
      }, 10000);
    };
    if (notification.show) {
      hideNotification();
    }
  }, [notification]);

  const filteredFloors = filterFloorsBySite(floors, site);

  const siteName = getSiteNameById(site, sitesList);
  const floorName = getFloorNameById(floor, floors);

  const handleCloseModal = () => {
    console.log("Closing modal...");
    setShowModal(false);
    // Reset form state when modal is closed
    setStep(1);
    setSendVideo(true);
    setSite("");
    setFloor("");
    setCompanionDeviceName("");
    setIsFloorDisabled(true);
    setIsNextDisabled(true);
  };

  const handleNext = (e) => {
    setSelectedButton("Next");
    if (step === 1) {
      setStep(2);
    } else if (step === 2) {
      setStep(3);
    } else if (step === 3) {
      setStep(4);
    } else if (step === 4) {
      setStep(5);
    } else {
      handleFormSubmit(e);
    }
  };
  useEffect(() => {
    console.log("showModal:", showModal);
    if (companionD != undefined) {
      const findIdData =
        companionD?.tagids != undefined && companionD?.tagids.length > 0
          ? companionD?.tagids[0]
          : "";
      const findIdDataTwo =
        companionD?.tagids != undefined && companionD?.tagids.length > 1
          ? companionD?.tagids[1]
          : "";
      const findSite = sitesList?.filter((site) => {
        return site?.id?.includes(findIdData);
      });

      const findSiteTwo = sitesList?.filter((site) => {
        return site?.id?.includes(findIdDataTwo);
      });

      const findFloor = floors?.filter((floor) => {
        return floor?.id?.includes(findIdData);
      });

      const findFloorTwo = floors?.filter((floor) => {
        return floor?.id?.includes(findIdDataTwo);
      });

      setSite(
        findSite.length > 0
          ? findSite?.[0].id
          : findSiteTwo.length > 0
          ? findSiteTwo?.[0]?.id
          : ""
      );
      setFloor(
        findFloor.length > 0
          ? findFloor?.[0].id
          : findFloorTwo.length > 0
          ? findFloorTwo?.[0].id
          : ""
      );
      setCompanionDeviceName(companionD?.name);
      setSendVideo(
        type == "companionInfoPage"
          ? eventVideoStatus
          : companionD?.customdata?.cansendmedia || true
      );
    }
  }, [showModal, companionD]);

  useEffect(() => {
    if (companionList?.length > 0) {
      const companionObj = companionList?.filter((item) => {
        return item.refid === selectedRowId;
      });
      setDeviceInfo(companionObj);
    }
  }, [selectedRowId]);
  const updateEvidenceStateOfCCD = async (e) => {
    console.log(e);
    var notificationInfo = {
      type: "Companion Devices Evidence Status Update",
      showNotification: true,
    };
    const aPIEndPoint = e
      ? enableEvidenceStatesEndPoint()
      : disableEvidenceStatesEndPoint();
    const deviceRefid = deviceInfo[0][deviceInfo[0].refidtype];
    try {
      const response = await axiosInstance.post(aPIEndPoint, {
        accountname: activeSession.accountId,
        resourceidentifier: { qrcode: deviceRefid },
      });
      if (response.status == 200) {
        notificationInfo = {
          type: "Companion Devices Evidence Status Updated",
          priority: "success",
          title: deviceInfo?.[0]?.name + " evidence status updated",
          showNotification: true,
        };
      } else {
        notificationInfo = {
          type: "Companion Devices Evidence Status Update",
          priority: "success",
          title: "Some error occured!",
          showNotification: true,
        };
      }
    } catch (e) {
      console.log(e);
      notificationInfo = {
        type: "Companion Devices Evidence Status Update",
        priority: "success",
        title: "Some error occured!",
        showNotification: true,
      };
      return;
    } finally {
      dispatch(showNotificationBanner(notificationInfo));
    }
  };

  const handleFormSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      let credentialsResponse = {};
      if (type !== "companionInfoPage") {
        credentialsResponse = await updateCameraCredentials(
          deviceInfo,
          cameraUsername,
          cameraPassword,
          activeSession
        );
      }
      if (type === "companionInfoPage" || credentialsResponse.success) {
        updateEvidenceStateOfCCD(sendVideo);
        const result = await PatchDeviceInfo(
          site,
          floor,
          sendVideo,
          companionDeviceName,
          activeSession,
          deviceInfo
        );

        if (result.success) {
          setLoading(false);
          handleCloseModal();
          dispatch(getAllCompanionDevices());

          const notificationInfo = {
            type: "Companion Devices Edit Details",
            priority: "success",
            data: { title: "Companion device details edited successfully." },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
          if (pathname !== "/companionDeviceInfoPage") {
            dispatch(getDiscoveredCamForComp(companionD?.qrcode));
          }
        } else {
          setLoading(false);
          console.error("Error submitting form:", result);
          const notificationInfo = {
            type: "Companion Devices Edit Details",
            priority: "success",
            data: { title: result.message },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
          // setNotification({
          //   show: true,
          //   type: "error",
          //   message: result.message,
          // });
        }
      } else {
        setLoading(false);
        handleCloseModal();
        const notificationInfo = {
          type: "Camera access credential error",
          priority: "warning",
          showNotification: true,
        };
        dispatch(showNotificationBanner(notificationInfo));
      }
    } catch (error) {
      setLoading(false);
      console.error("Error submitting form:", error);
      setNotification({ show: true, type: "error", message: error.message });
    }
  };

  const modifyStepValue = (value) => {
    if (pathname === "/companionDeviceInfoPage") {
      if (value === 2 && selectedButton === "Next") {
        setStep(3);
        return 3;
      } else if (value === 2 && selectedButton === "Back") {
        setStep(1);
        return 1;
      } else {
        return value;
      }
    } else {
      return value;
    }
  };

  const renderStepContent = () => {
    switch (modifyStepValue(step)) {
      case 1:
        return (
          <>
            <div style={{ marginBottom: "2%" }}>
              <Body size="medium">Step 1/4: Location</Body>
            </div>
            <Title bold={true} size="medium">
              Companion device details
            </Title>
            <div style={{ marginTop: "5%", marginBottom: "5%" }}>
              <Body size="medium">
                Select the location where this companion device is located.
              </Body>
            </div>
            <div style={{ marginBottom: "5%" }}>
              <DropdownSelect
                label="Site"
                errorText="Select a state"
                error={false}
                disabled={false}
                readOnly={false}
                inlineLabel={false}
                value={site}
                data-testid="companionOnboardingModal_selectASiteDropdownSelect"
                onChange={(e) => setSite(e.target.value)}
              >
                <option key="placeholder-site" value="" disabled>
                  {" "}
                  Select a Site
                </option>
                {Array.isArray(sitesList) &&
                  sitesList.map((site) => (
                    <option key={site.id} value={site.id}>
                      {site.name}
                    </option>
                  ))}
              </DropdownSelect>
            </div>
            <div style={{ marginBottom: "5%" }}>
              <DropdownSelect
                label="Floor"
                errorText="Select a Floor"
                error={false}
                disabled={isFloorDisabled}
                readOnly={false}
                inlineLabel={false}
                required={false}
                value={floor}
                data-testid="companionOnboardingModal_selectAFloorDropdownSelect"
                onChange={(e) => setFloor(e.target.value)}
              >
                <option key="placeholder-floor" value=""> </option>
                {filteredFloors?.map((floor) => (
                  <option key={floor.id} value={floor.id}>
                    {floor.name}
                  </option>
                ))}
              </DropdownSelect>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                size="medium"
                disabled={false}
                width="45%"
                use="secondary"
                data-testid="companionOnboardingModal_case1BackButton"
                onClick={handleCloseModal}
              >
                Back
              </Button>
              <Button
                size="medium"
                width="45%"
                disabled={isNextDisabled}
                use="primary"
                data-testid="companionOnboardingModal_case1NextButton"
                onClick={handleNext}
              >
                Next
              </Button>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div style={{ marginBottom: "2%" }}>
              <Body size="medium">Step 2/4: Camera access credentials</Body>
            </div>
            <Title bold={true} size="medium">
              Companion device details
            </Title>
            <div style={{ marginTop: "5%", marginBottom: "5%" }}>
              <Body size="medium">
                Camera access credentials. Specify user name and password that
                you use to access your cameras.
              </Body>
            </div>
            <div
              style={{
                marginTop: "4%",
                marginBottom: "4%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Input
                type="text"
                label="Username"
                required={true}
                readOnly={false}
                width="48%"
                value={cameraUsername}
                disabled={false}
                data-testid="companionOnboardingModal_usernameInput"
                onChange={(e) => setCameraUsername(e.target.value)}
              />
              <Input
                type="password"
                label="Password"
                mask="toggle"
                width="48%"
                readOnly={false}
                required={true}
                value={cameraPassword}
                disabled={false}
                data-testid="companionOnboardingModal_passwordInput"
                onChange={(e) => setCameraPassword(e.target.value)}
              />
            </div>
            <div
              style={{
                marginBottom: "5%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                size="medium"
                width="45%"
                disabled={false}
                use="secondary"
                data-testid="companionOnboardingModal_case2BackButton"
                onClick={() => {
                  setSelectedButton("Back");
                  setStep(1);
                }}
              >
                Back
              </Button>
              <Button
                size="medium"
                width="45%"
                disabled={isNextDisabled || sendVideo === null}
                use="primary"
                data-testid="companionOnboardingModal_case1NextButton"
                onClick={handleNext}
              >
                Next
              </Button>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <div style={{ marginBottom: "2%" }}>
              <Body size="medium">Step 3/4: Media settings</Body>
            </div>
            <Title bold={true} size="medium">
              Companion device details
            </Title>
            <div style={{ marginTop: "5%", marginBottom: "5%" }}>
              <Body size="medium">
                Would you like this companion device to send video and images to
                the 5G Video Insights portal?
              </Body>
            </div>
            <div style={{ marginBottom: "5%", display: "flex", gap: "2%" }}>
              <RadioBox
                selected={sendVideo === true}
                data-testid="companionOnboardingModal_yesRadioBox"
                onChange={() => {
                  setSendVideo(true);
                  setIsNextDisabled(false);
                }}
                text={"Yes"}
                subtext={"Send video and images"}
              />
              <RadioBox
                selected={sendVideo === false}
                data-testid="companionOnboardingModal_noRadioBox"
                onChange={() => {
                  setSendVideo(false);
                  setIsNextDisabled(false);
                }}
                text={"No"}
                subtext={"Do not send video and images"}
              />
            </div>
            <div
              style={{
                marginBottom: "5%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                size="medium"
                width="45%"
                disabled={false}
                use="secondary"
                data-testid="companionOnboardingModal_case3BackButton"
                onClick={() => {
                  setSelectedButton("Back");
                  setStep(2);
                }}
              >
                Back
              </Button>
              <Button
                size="medium"
                width="45%"
                disabled={isNextDisabled || sendVideo === null}
                use="primary"
                data-testid="companionOnboardingModal_case3NextButton"
                onClick={handleNext}
              >
                Next
              </Button>
            </div>
          </>
        );
      case 4:
        return (
          <>
            <div style={{ marginBottom: "2%" }}>
              <Body size="medium">Step 4/4: Device name</Body>
            </div>
            <Title bold={true} size="medium">
              Companion device details
            </Title>
            <div style={{ marginTop: "5%", marginBottom: "5%" }}>
              <Body size="medium">Finish by naming this companion device.</Body>
            </div>
            <div style={{ marginBottom: "5%" }}>
              <Input
                type="text"
                label="Companion device name"
                readOnly={false}
                required={true}
                disabled={false}
                error={false}
                errorText="Enter a valid name."
                value={companionDeviceName}
                data-testid="companionOnboardingModal_companionDeviceNameInput"
                onChange={(e) => {
                  setCompanionDeviceName(e.target.value);
                  setIsNextDisabled(e.target.value.trim() === "");
                }}
              />
            </div>
            <div
              style={{
                marginBottom: "5%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                size="medium"
                width="45%"
                disabled={false}
                use="secondary"
                data-testid="companionOnboardingModal_case4BackButton"
                onClick={() => {
                  setSelectedButton("Back");
                  setStep(3);
                }}
              >
                Back
              </Button>
              <Button
                size="medium"
                width="45%"
                disabled={isNextDisabled || companionDeviceName.trim() === ""}
                use="primary"
                data-testid="companionOnboardingModal_case4NextButton"
                onClick={handleNext}
              >
                Next
              </Button>
            </div>
          </>
        );
      case 5:
        return (
          <form onSubmit={handleFormSubmit}>
            <Title bold={true} size="medium">
              Review
            </Title>
            <div style={{ marginTop: "4%", marginBottom: "4%" }}>
              <Input
                type="text"
                label="Companion device name"
                readOnly={true}
                value={companionDeviceName}
              />
            </div>
            <Line type="secondary" />
            <div style={{ marginTop: "4%", marginBottom: "4%" }}>
              <Input
                type="text"
                label="Site"
                readOnly={true}
                value={siteName}
              />
            </div>
            <div style={{ marginTop: "4%", marginBottom: "4%" }}>
              <Input
                type="text"
                label="Floor"
                required={false}
                readOnly={true}
                value={floorName}
              />
            </div>
            {type !== "companionInfoPage" && (
              <>
                <Line type="secondary" />
                <div
                  style={{
                    marginTop: "4%",
                    marginBottom: "4%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Input
                    type="text"
                    label="Username"
                    readOnly={true}
                    width="48%"
                    value={cameraUsername}
                  />
                  <Input
                    type="password"
                    label="Password"
                    mask="toggle"
                    width="48%"
                    readOnly={false}
                    value={cameraPassword}
                  />
                </div>
              </>
            )}
            <Line type="secondary" />
            <div style={{ marginTop: "4%", marginBottom: "4%" }}>
              <RadioBox
                selected={sendVideo}
                text={sendVideo ? "Yes" : "No"}
                subtext={
                  sendVideo
                    ? "Send video and images"
                    : "Do not send video and images"
                }
                readOnly={true}
              />
            </div>
            <div
              style={{
                marginTop: "5%",
                marginBottom: "5%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                size="medium"
                width="45%"
                disabled={false}
                use="secondary"
                data-testid="companionOnboardingModal_case5BackButton"
                onClick={() => {
                  setSelectedButton("Back");
                  setStep(4);
                }}
              >
                Back
              </Button>
              <Button
                size="medium"
                width="45%"
                disabled={false}
                use="primary"
                data-testid="companionOnboardingModal_case5NextButton"
                onClick={handleNext}
              >
                Submit
              </Button>
            </div>
          </form>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      {/* {notification.show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            width: "auto",
          }}
        >
          <Notification
            type={notification.type}
            title={notification.message}
            fullBleed={false}
            inline={false}
            disableFocus={true}
          />
        </div>
        )} */}
      <Modal
        opened={showModal}
        onOpenedChange={(opened) => {
          if (!opened) {
            handleCloseModal();
          }
        }}
        ariaLabel={title}
      >
        {renderStepContent()}
        {loading && <Loader active fullscreen={true} disableFocusLock surface="light" />}
      </Modal>
    </div>
  );
};

export default CompanionOnboardingModal;
